import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useScrollToTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null;
};

export const useScrollToTopOnPathnameChange = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export const useScrollToTopOnCategory = () => {
  useEffect(() => {
    const originalScrollRestoration = window.history.scrollRestoration;

    if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";

    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });

    return () => {
      if ("scrollRestoration" in window.history) window.history.scrollRestoration = originalScrollRestoration;
    };
  }, []);
};

export default useScrollToTop;
